export default __webpack_public_path__ + "static/media/button-Camera-On.0e9b47a1.png";